import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles/index';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import ContinueButton from '../../common/components/Buttons/ContinueButton';
import ProductCard from '../../common/components/FormStepper/ProductCard';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: `calc(100% - ${unit * 3}px)`,
        paddingBottom: '24px',
        paddingTop: '16px',
    },
    gridContainer: {
        margin: unit,
    },
    button: {
        marginLeft: unit * 2,
        '&:first-child': {
            marginLeft: 0,
        },
    },
    buttons: {
        marginTop: unit * 2,
        marginBottom: unit * 2,
    },
});

function SelectBestOfferContainer(props) {
    const setSelectedProduct = (offer) => {
        props.setBestOffer(offer);
        props.setStepCompleted(8, true);
    };
    return props.isPending
        ? (
            <CircularProgress />
        )
        : (
            <div className={props.classes.root}>
                <div>
                    {props.bestOffers.length === 0 &&
                    <Typography variant="headline" component="h4">
                        There no products available for this search criteria
                    </Typography>
                    }
                    <Grid
                        container
                        spacing={16}
                        className={props.classes.gridContainer}
                    >
                        {props.bestOffers.map((product, index) => (
                            <Grid
                                item
                                xs={12}
                                sm={4}
                                key={product.productCode}
                            >
                                <ProductCard
                                    isSelected={props.selectedOffer === index}
                                    onSelect={() => setSelectedProduct(index)}
                                    product={product}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </div>
                <div className={props.classes.buttons}>
                    <Button
                        className={props.classes.button}
                        color="default"
                        onClick={() => {
                            props.setStep(7);
                            props.setStepCompleted(8, false);
                        }}
                    >
                    Back
                    </Button>
                    <ContinueButton
                        className={props.classes.button}
                        disabled={props.selectedOffer === -1}
                        onClick={() => {
                            props.setStep(9);
                            props.setStepCompleted(8, true);
                        }}
                    />
                </div>
            </div>
        );
}

SelectBestOfferContainer.propTypes = {
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    isPending: PropTypes.bool.isRequired,
    bestOffers: PropTypes.array.isRequired,
    setBestOffer: PropTypes.func.isRequired,
    selectedOffer: PropTypes.number.isRequired,
};

export default withStyles(styles)(SelectBestOfferContainer);



// WEBPACK FOOTER //
// ./src/app/FormStepper/SelectBestOffer/SelectBestOffer.js